import { Box, useTheme } from '@mui/material';

import { ATSAutomationCreateTestIds } from 'data-testids/ATS';
import { AutomationModalPaneOptions } from 'features/Automations/enums';
import { CreateAutomationCTAButtonsProps } from 'features/Automations/types';
import { useAutomation } from 'features/Automations/context/AutomationContext';
import { PrimaryButton, SecondaryButton } from 'sharedComponents/Buttons';
import {
  primaryButtonOverrideSx,
  secondaryButtonOverrideSx,
} from 'sharedComponents/Buttons/styles';

export const CreateAutomationCTAButtons: React.FC<CreateAutomationCTAButtonsProps> = ({
  hasError,
  isDisabled = false,
}) => {
  const theme = useTheme();
  const { onChangeModalPane } = useAutomation();

  return (
    <Box sx={{ pt: 3, display: 'flex', justifyContent: 'end' }}>
      <SecondaryButton
        dataTestId={ATSAutomationCreateTestIds.DISCARD_BUTTON}
        onClick={() => onChangeModalPane(AutomationModalPaneOptions.LIST)}
        sx={{ ...secondaryButtonOverrideSx(theme), mr: 1 }}
      >
        Discard
      </SecondaryButton>
      <PrimaryButton
        type="submit"
        dataTestId={ATSAutomationCreateTestIds.SAVE_BUTTON}
        sx={primaryButtonOverrideSx(theme)}
        disabled={hasError || isDisabled}
      >
        Save
      </PrimaryButton>
    </Box>
  );
};
